import Bowser from 'bowser';

const browser = Bowser.getParser(window.navigator.userAgent);

const versions = {
  iphone: 7,
  ipad: 7,
  android: 4,
  internetExplorer: 11,
  firefox: 27,
  chrome: 35,
  chromeMobile: 35,
  safari: 6.1,
  opera: 20,
};

const isBrowserSupported = () => {
  //Whether the browser satisfies the set conditions or not.
  //Returns undefined when the browser is not described in the object.
  const isSupported = browser.satisfies({
    mobile: {
      chrome: `>=${versions.chromeMobile}`,
    },
    chrome: `>=${versions.chrome}`,
    safari: `>=${versions.safari}`,
    opera: `>=${versions.opera}`,
    firefox: `>=${versions.firefox}`,
    //this will return false for any internet explorer version =< 11
    ie: `>${versions.internetExplorer}`,
    Android: `>=${versions.android}`,
    iOS: `>=${versions.iphone}`,
  });

  return isSupported === undefined ? true : isSupported;
};

export const bowser = {
  msie: browser.isBrowser('ie', true),
  firefox: browser.isBrowser('firefox', true),
  safari: browser.isBrowser('safari', true),
  chrome: browser.isBrowser('chrome', true),
  opera: browser.isBrowser('opera', true),
  version: browser.getBrowser().version,
  android: browser.getOSName(true) === 'android',
  isBrowserSupported,
  ...browser,
};
